var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.254,
    height: 29.254,
    viewBox: "0 0 29.254 29.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_58",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 58",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_57",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M1287.878,36.667H1279.5v9.44",
    transform: "translate(-1279.5 -36.667)",
    fill: "none",
    stroke: "#0071b9",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M1279.5,78.266v7.315h8.378",
    transform: "translate(-1279.5 -59.327)",
    fill: "none",
    stroke: "#0071b9",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M1327.143,46.107v-9.44h-8.378",
    transform: "translate(-1300.889 -36.667)",
    fill: "none",
    stroke: "#0071b9",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M1318.766,85.581h8.378V78.266",
    transform: "translate(-1300.889 -59.327)",
    fill: "none",
    stroke: "#0071b9",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default __webpack_public_path__ + "static/media/icon_fullscreen.b2aef098f299b0b6c9ee1179fb3f83c9.svg";
export { ForwardRef as ReactComponent };